exports.ByName = {
  TotalNetSales: { Id: 1, Name: 'financial_type.total_net_sales', propertyName: 'netSales' },
  CostOfGoodsSold: { Id: 2, Name: 'financial_type.cost_of_goods_sold', propertyName: 'costOfGoodsSold' },
  GrossProfit: { Id: 3, Name: 'financial_type.gross_profit', propertyName: 'grossProfit' },
  OperatingExpenses: { Id: 4, Name: 'financial_type.operating_expenses', propertyName: 'operatingExpenses' },
  OperatingProfit: { Id: 5, Name: 'financial_type.operating_profit', propertyName: 'operatingIncome' },
  InterestExpense: { Id: 6, Name: 'financial_type.interest_expense', propertyName: 'interestExpenses' },
  RdExpense: { Id: 7, Name: 'financial_type.rd_expense', propertyName: 'rndExpense' },
  AdvertisingExpense: { Id: 8, Name: 'financial_type.advertising_expense', propertyName: 'advertisingExpenses' },
  AvgTotalAssets: { Id: 9, Name: 'financial_type.avg_total_assets', propertyName: 'totalAssets' },
  AvgOperatingAssets: { Id: 10, Name: 'financial_type.avg_opperating_assets', propertyName: 'operatingAssets' },
  AvgNetPayables: { Id: 11, Name: 'financial_type.avg_net_payables', propertyName: 'avgNetPayables' },
  NetReceivables: { Id: 12, Name: 'financial_type.avg_net_receivables', propertyName: 'avgNetReceivables' },
  AvgNetPpe: { Id: 13, Name: 'financial_type.avg_net_ppe', propertyName: 'avgNetPpe' },
  AvgNetInventory: { Id: 14, Name: 'financial_type.avg_net_inventory', propertyName: 'avgNetInventory' },
  AvgCach: { Id: 15, Name: 'financial_type.avg_cach', propertyName: 'avgCash' },
  AvgCashAndEquivalents: { Id: 16, Name: 'financial_type.avg_cash_and_equivalents', propertyName: 'avgCashAndEquivalents' },
  AvgInvestedCapital: { Id: 17, Name: 'financial_type.avg_invested_capital', propertyName: 'avgInvestedCapital' }
};

exports.ById = {
  1: { Id: 1, Name: 'financial_type.total_net_sales', propertyName: 'netSales' },
  2: { Id: 2, Name: 'financial_type.cost_of_goods_sold', propertyName: 'costOfGoodsSold' },
  3: { Id: 3, Name: 'financial_type.gross_profit', propertyName: 'grossProfit' },
  4: { Id: 4, Name: 'financial_type.operating_expenses', propertyName: 'operatingExpenses' },
  5: { Id: 5, Name: 'financial_type.operating_profit', propertyName: 'operatingIncome' },
  6: { Id: 6, Name: 'financial_type.interest_expense', propertyName: 'interestExpenses' },
  7: { Id: 7, Name: 'financial_type.rd_expense', propertyName: 'rndExpense' },
  8: { Id: 8, Name: 'financial_type.advertising_expense', propertyName: 'advertisingExpenses' },
  9: { Id: 9, Name: 'financial_type.avg_total_assets', propertyName: 'totalAssets' },
  10: { Id: 10, Name: 'financial_type.avg_opperating_assets', propertyName: 'operatingAssets' },
  11: { Id: 11, Name: 'financial_type.avg_net_payables', propertyName: 'avgNetPayables' },
  12: { Id: 12, Name: 'financial_type.avg_net_receivables', propertyName: 'avgNetReceivables' },
  13: { Id: 13, Name: 'financial_type.avg_net_ppe', propertyName: 'avgNetPpe' },
  14: { Id: 14, Name: 'financial_type.avg_net_inventory', propertyName: 'avgNetInventory' },
  15: { Id: 15, Name: 'financial_type.avg_cach', propertyName: 'avgCash' },
  16: { Id: 16, Name: 'financial_type.avg_cash_and_equivalents', propertyName: 'avgCashAndEquivalents' },
  17: { Id: 17, Name: 'financial_type.avg_invested_capital', propertyName: 'avgInvestedCapital' }
};

exports.ByType = {
  IncomeStatement: [1, 2, 3, 4, 5, 6, 7, 8],
  BalanceSheet: [9, 10, 11, 12, 13, 14, 15, 16, 17]
};
